import sqAL from '../../date-picker/locale/sq_AL';
export default sqAL;
